import { Component, inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { TpaSearchCoverageResExtended } from '../../models/http/tpa-http.model';
import { CommonModule } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';
import { MatButton } from '@angular/material/button';
import { TpaGroupService } from '../../services/tpa-group.service';
import { GroupedTpaCoverage } from '../../models/tpa-group.model';
import { FormsModule } from '@angular/forms';
import { TpaView } from '../../models/tpa.enum';
import { TpaDetailViewComponent } from './components/tpa-detail-view/tpa-detail-view.component';
import { TpaGroupViewComponent } from './components/tpa-group-view/tpa-group-view.component';
import { QuickSearchComponent } from '../../../../shared/components/quick-search/quick-search.component';
import { InputModel } from '../../../../shared/components/input/models/input.model';
import { TpaDialogComponent } from './components/tpa-dialog/tpa-dialog.component';
import { TpaViewToggleComponent } from './components/tpa-view-toggle/tpa-view-toggle.component';
import { TpaDetailsStateService } from './services/tpa-details-state.service';
import { TpaFilterComponent } from './components/tpa-filter/tpa-filter.component';
import { TpaService } from '../../services/tpa.service';

@Component({
  selector: 'app-tpa-details',
  standalone: true,
  imports: [
    CommonModule,
    MatButton,
    FormsModule,
    TpaDetailViewComponent,
    TpaGroupViewComponent,
    QuickSearchComponent,
    TpaDialogComponent,
    TpaViewToggleComponent,
    TpaFilterComponent,
  ],
  templateUrl: './tpa-details.component.html',
  styleUrl: './tpa-details.component.scss',
})
export class TpaDetailsComponent implements OnInit, OnDestroy {
  tpaView = TpaView;
  groupViewData!: GroupedTpaCoverage;
  tpaGroupService = inject(TpaGroupService);
  currentView: TpaView = this.tpaView.group;
  filteredData: TpaSearchCoverageResExtended[] = [];
  searchOptions: InputModel = {
    value: '',
  };

  private tpaDetailStateService = inject(TpaDetailsStateService);
  private tpaService = inject(TpaService);

  private destroy$ = new Subject<void>();

  @Input()
  set detailViewData(value: TpaSearchCoverageResExtended[] | []) {
    this.filteredData = value || [];
    this.resetSearch();
    this.tpaDetailStateService.setDataSource(value);
  }

  get detailViewData(): TpaSearchCoverageResExtended[] | [] {
    return this.tpaDetailStateService.getDataSourceValue();
  }

  @Output() goBack = new Subject<void>();

  ngOnInit() {
    this.initSearchData();
  }

  onFilteredDataChange(filteredData: TpaSearchCoverageResExtended[]) {
    this.tpaDetailStateService.emitFilterChange({
      ...this.tpaDetailStateService.getFiltersValue(),
      searchFilteredData: filteredData,
    });
  }

  onViewAction(view: TpaView) {
    this.currentView = view;
  }

  back() {
    this.resetSearch();
    this.tpaService.tpaNavigateTo('search');
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private resetSearch() {
    this.searchOptions = { value: '' };
    this.tpaDetailStateService.emitFilterChange({
      ...this.tpaDetailStateService.getFiltersValue(),
      searchFilteredData: null,
    });
  }

  private initSearchData() {
    this.tpaService.searchResults$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.detailViewData = data || [];
      this.initDataSource();
    });
  }

  private initDataSource() {
    this.tpaDetailStateService.subscribeToDataSource().subscribe((filteredData) => {
      this.filteredData = filteredData;
      this.groupViewData = this.tpaGroupService.groupCensusLines(filteredData);
    });
  }
}
